import { FileInfo } from "@/common/file-info";
import { DateTime } from "@/fx/data-helpers";
import { blobString, downloadUrl, tryUploadedAt } from "./adapters/filestore";

export namespace F {
  export type Service = {
    getDownloadUrl:   (file: FileInfo) => Promise<string              >;
    tryGetUploadedAt: (id: string    ) => Promise<DateTime | undefined>;
    getBlobString:    (id: string    ) => Promise<string              >;
  }
}

export async function files(): Promise<F.Service> {
  return {
    getDownloadUrl:   async (file: FileInfo) => downloadUrl  (file),
    tryGetUploadedAt: async (id:   string  ) => tryUploadedAt(id  ),
    getBlobString:    async (id:   string  ) => blobString   (id  ),
  };
}
